import { render, staticRenderFns } from "./actor.vue?vue&type=template&id=6b0ce2da&"
import script from "./actor.vue?vue&type=script&lang=js&"
export * from "./actor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports